"use strict";
export var ReactQueryCacheKey = /* @__PURE__ */ ((ReactQueryCacheKey2) => {
  ReactQueryCacheKey2["BalanceAndUnitags"] = "BalanceAndUnitags";
  ReactQueryCacheKey2["CameraPermission"] = "CameraPermission";
  ReactQueryCacheKey2["CancelTransactionRequest"] = "CancelTransactionRequest";
  ReactQueryCacheKey2["CancelUniswapXTransactionRequest"] = "CancelUniswapXTransactionRequest";
  ReactQueryCacheKey2["CreateTransferTransaction"] = "CreateTransferTransaction";
  ReactQueryCacheKey2["DensityChartData"] = "DensityChartData";
  ReactQueryCacheKey2["ExtractedColors"] = "ExtractedColors";
  ReactQueryCacheKey2["GeneratedAddresses"] = "GeneratedAddresses";
  ReactQueryCacheKey2["IsErc20ContractAddress"] = "IsErc20ContractAddress";
  ReactQueryCacheKey2["IsSmartContractAddress"] = "IsSmartContractAddress";
  ReactQueryCacheKey2["LocalActivities"] = "localActivities";
  ReactQueryCacheKey2["MismatchAccount"] = "MismatchAccount";
  ReactQueryCacheKey2["MnemonicUnlocked"] = "MnemonicUnlocked";
  ReactQueryCacheKey2["OnboardingRedirect"] = "OnboardingRedirect";
  ReactQueryCacheKey2["OnchainBalances"] = "OnchainBalances";
  ReactQueryCacheKey2["OnchainENS"] = "OnchainENS";
  ReactQueryCacheKey2["PasskeyAuthStatus"] = "PasskeyAuthStatus";
  ReactQueryCacheKey2["Permit2SignatureWithData"] = "Permit2SignatureWithData";
  ReactQueryCacheKey2["PositionCurrencyInfo"] = "positionCurrencyInfo";
  ReactQueryCacheKey2["PositionTokenURI"] = "PositionTokenURI";
  ReactQueryCacheKey2["RemoteSvg"] = "RemoteSvg";
  ReactQueryCacheKey2["SignatureToActivity"] = "SignatureToActivity";
  ReactQueryCacheKey2["StatsigUser"] = "StatsigUser";
  ReactQueryCacheKey2["TradingApi"] = "TradingApi";
  ReactQueryCacheKey2["TransactionToActivity"] = "TransactionToActivity";
  ReactQueryCacheKey2["UniqueId"] = "UniqueId";
  ReactQueryCacheKey2["UniswapApi"] = "UniswapApi";
  ReactQueryCacheKey2["UnitagsApi"] = "UnitagsApi";
  ReactQueryCacheKey2["WalletDelegation"] = "WalletDelegation";
  ReactQueryCacheKey2["WalletGetCapabilities"] = "WalletGetCapabilities";
  ReactQueryCacheKey2["WebTransactionGasFee"] = "WebTransactionGasFee";
  ReactQueryCacheKey2["WrapTransactionRequest"] = "WrapTransactionRequest";
  return ReactQueryCacheKey2;
})(ReactQueryCacheKey || {});
export const DISABLE_CACHE_PERSISTENCE_TO_DISK = [];
